import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledMainContainer = styled.div`
  max-width: ${(props) => props.theme.size.grid020};

  @media (min-width: ${Breakpoints.b1600}px) {
    max-width: ${(props) => props.theme.size.grid010};
  }
`;

export const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${(props) => props.theme.size.static400};
  flex-shrink: 0;
  align-self: stretch;
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledTab = styled.div`
  > div > div {
    column-gap: ${(props) => props.theme.size.static250};
  }
`;

export const StyledSubmitButton = styled.div`
  margin-top: ${(props) => props.theme.size.static400};
  width: 100%;
`;

export const StyledInfoboxContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${(props) => props.theme.size.static400};

  & [class^='StyledInfobox-'],
  & [class*=' StyledInfobox-'] {
    width: 100% !important;
    box-sizing: border-box;
  }
`;
